import styled from "styled-components";
import { Col, Text } from "@website-builder/ui/shared/elements";
import {
	MOBILE_SM_BP,
	TABLET_M_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const ContentGridWrapper = styled.div`
	padding: 5rem 0;
	width: fit-content;

	.text-color-gray {
		color: var(--secondary-gray-dark);
	}

	.text-color-white {
		color: var(--primary-neutral-white);
	}

	.content-grid-video-modal {
		width: 70%;
		transform: translate(-50%, -50%);
		top: 50%;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.content-grid-video-modal {
			width: calc(100% - 10rem);
			height: auto;
			padding: 80px 0;
		}
		.content-grid-video-modal .closeButtonWrapper {
			right: 0;
		}
	}
	@media screen and (orientation: landscape) and (min-device-width: ${MOBILE_SM_BP}px) and (max-device-width: ${TABLET_M_BP}px) {
		.content-grid-video-modal {
			width: calc(100% - 15rem);
			height: auto;
			padding: 80px 10%;
		}
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.content-grid-slider {
			.slick-active {
				text-align: center;
			}
		}
	}
`;
export const ColHeadingWrapper = styled(Col)`
	display: flex !important;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;

	.content-grid-heading-cta {
		margin-right: 16px;
	}

	@media only screen and (min-width: ${TABLET_M_BP}px) {
		${({ isDesktopViewCarousel }) =>
			isDesktopViewCarousel && `padding: 0 4rem;`}
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		text-align: center;
		justify-content: center;
	}
`;

export const TextHeadline = styled(Text)`
	margin-top: 12px;
`;

export const ColButtonWrapper = styled(Col)`
	justify-self: center;
	position: relative;
	top: 40px;

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		top: 54px;
	}
`;

export const ItemsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	overflow: scroll;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 416px;
	padding-right: 16px;
`;

export const ImageContainer = styled.div`
	.content-grid-item-image {
		width: 100%;
		max-width: 416px;
		height: 240px;
		object-fit: cover;
		border-radius: 8px;
		margin-bottom: 16px;
	}
`;

export const VideoWrapper = styled.div`
	.content-grid-item-video img {
		width: 100%;
		max-width: 416px;
		height: 240px;
		object-fit: cover;
		border-radius: 8px;
		margin-bottom: 16px;
	}
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	text-align: left;

	& > a {
		text-decoration: underline;
	}
`;

export const LabelContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;

	.content-grid-item-badge {
		height: fit-content;
	}
`;
